import { render, staticRenderFns } from "./HJ0035.vue?vue&type=template&id=9b895412&scoped=true&"
import script from "./HJ0035.vue?vue&type=script&lang=js&"
export * from "./HJ0035.vue?vue&type=script&lang=js&"
import style0 from "./HJ0035.vue?vue&type=style&index=0&id=9b895412&prod&lang=less&scoped=true&"
import style1 from "./HJ0035.vue?vue&type=style&index=1&id=9b895412&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b895412",
  null
  
)

export default component.exports